import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dd9b1f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fs-3" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZKeyValue = _resolveComponent("VZKeyValue")!
  const _component_vz_user_phone_modal = _resolveComponent("vz-user-phone-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VZKeyValue, {
      items: _ctx.items,
      showCard: _ctx.showCard
    }, _createSlots({ _: 2 }, [
      (_ctx.data.userPhone?.length > 0)
        ? {
            name: "phoneNumber",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.userPhone[0]?.phone_number) + " ", 1),
              (_ctx.data.userPhone.length > 1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showPhoneDialog = true), ["stop"])),
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3"
                  }, _hoisted_2))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["items", "showCard"]),
    _createVNode(_component_vz_user_phone_modal, {
      phone: _ctx.data.userPhone,
      id: "vz_user_detail_phone_modal",
      showDialog: _ctx.showPhoneDialog,
      onModalClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPhoneDialog = false)),
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPhoneDialog = false))
    }, null, 8, ["phone", "showDialog"])
  ]))
}